'use client'

import { Rotate36016 } from '@vinted/monochrome-icons'
import { Cell, Icon, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useDate } from '@marketplace-web/shared/ui-helpers'

type Props = {
  lastUpdatedTime: string
}

const LastUpdatedTime = ({ lastUpdatedTime }: Props) => {
  const translate = useTranslate('closet_promotion.performance')
  const { formatRelativeTime } = useDate()

  const renderPrefix = () => {
    return (
      <div className="u-flexbox u-align-items-center u-fill-height">
        <Icon
          name={Rotate36016}
          color={Icon.Color.GreyscaleLevel2}
          aria={{ 'aria-hidden': 'true' }}
        />
      </div>
    )
  }

  return (
    <Cell
      styling={Cell.Styling.Tight}
      prefix={renderPrefix()}
      body={
        <Text
          as="span"
          type={Text.Type.Subtitle}
          text={translate('last_updated', { time: formatRelativeTime(lastUpdatedTime) })}
        />
      }
    />
  )
}

export default LastUpdatedTime
